import { createContext, useContext } from 'react';

import type { ResourceVersionListItem, VersionedResourceType } from '@/types';

import type { PreviewChange } from './changes';

export interface ResourcePreviewChangesValue {
    changes: PreviewChange[];
    highlightChanges: boolean;
    resourceId: string;
    resourceType: VersionedResourceType;
    version: ResourceVersionListItem;
}

export const ResourcePreviewChangesContext = createContext<ResourcePreviewChangesValue | null>(null);
export const useResourcePreviewChanges = () => useContext(ResourcePreviewChangesContext);
